import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";

import { useDispatch } from "../../../redux/hooks";
import { setLoggedIn } from "../../../redux/slices/auth/authSlice";

import PublicFormContainer from "./PublicFormContainer";

const AccountSuccessRedirecting = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        setTimeout(() => {
            dispatch(setLoggedIn());
        }, 1000);
    }, [dispatch]);

    return (
        <PublicFormContainer>
            <h2 className="mb-4">
                Your account has been set up successfully.
            </h2>
            <p className="mb-5">
                Please wait for a moment while we direct you to your dashboard.
            </p>
            <div>
                <StyledCircle delay={0} duration={800} />
                <StyledCircle delay={150} duration={800} />
                <StyledCircle delay={300} duration={800} />
            </div>
        </PublicFormContainer>
    );
};

export default AccountSuccessRedirecting;

const breatheAnimation = keyframes`
    0% { opacity: 1;}
    100% { opacity: 0; }
`;

const StyledCircle = styled.span<{ delay: number; duration: number }>`
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 12px;
    background-color: #cbcbcb;
    border-radius: 50%;
    animation: ${breatheAnimation} ${({ duration }) => duration}ms
        ${({ delay }) => delay}ms infinite alternate;
`;
